import { http } from 'http';

export default {
  saveAct: data =>
    http.put(`/flex/checkinout/dataFlexCheck`, data, {
      headers: {
        'content-type': 'application/json-patch+json'
      }
    }),

  saveActTransfer: data =>
    http.put(`/flex/checkinoutTransfer/dataFlexCheck`, data, {
      headers: {
        'content-type': 'application/json-patch+json'
      }
    })
};
